<ng-container *ngIf="growProjectsLoaded$ | async; else showLoadingBar">
  <div class="impact-projects" *ngIf="growProjects$ | async as projects">
    @for (project of projects; track project) {
      <div>
        <app-grow-project [project]="project" [growAccount]="growAccount" (click)="showProjectDetails(project)"></app-grow-project>
        <div *ngIf="viewProjectDetail === project.id">
          <app-grow-project-detail-dialog
            [project]="project"
            [growAccount]="growAccount"
            (closeProject)="hideProjectDetails()"
          ></app-grow-project-detail-dialog>
        </div>
      </div>
    }

    <div *ngIf="projects.length < 5" class="project-placeholder-holder">
      <div class="project-placeholder">
        <app-ds-rounded-icon icon="sparkles" variant="info" color="var(--color-core-neutral-10)" />
        <h4 class="ds-heading-2">{{ 'GROW.performance.assets.projectPlaceholder.title' | translate }}</h4>
        <p class="ds-ui-3 ds-color-core-neutral-8">{{ 'GROW.performance.assets.projectPlaceholder.body' | translate }}</p>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #showLoadingBar>
  <div class="skeleton-wrapper impact-projects">
    <div>
      <div class="skeleton project"></div>
    </div>
    <div>
      <div class="skeleton project"></div>
    </div>
  </div>
</ng-template>
